// src/pages/Contact.jsx
import React, { useState } from 'react';

const Contact = () => {
    // Estado para os dados do formulário
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    // Limite de caracteres para a mensagem
    const characterLimit = 250;

    // Função para redirecionar para o WhatsApp com os dados do formulário
    const handleSubmit = () => {
        const messageText = `*Nome*: ${name}\n*Email*: ${email}\n*Mensagem*: ${message}`;
        const whatsappUrl = `https://wa.me/5585982007804?text=${encodeURIComponent(messageText)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="w-full bg-gradient-to-b from-purple-100 via-purple-200 to-white py-12 mt-12">
            <h2 className="text-center text-4xl font-bold text-purple-600 mb-8">Entre em Contato</h2>

            <div className="max-w-4xl mx-auto p-8 bg-white shadow-xl rounded-2xl">
                <form className="space-y-6">
                    {/* Nome */}
                    <div>
                        <label className="block text-lg font-semibold text-purple-700" htmlFor="name">
                            Nome
                        </label>
                        <input
                            type="text"
                            id="name"
                            className="w-full p-3 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
                            placeholder="Seu nome"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    {/* E-mail */}
                    <div>
                        <label className="block text-lg font-semibold text-purple-700" htmlFor="email">
                            E-mail
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="w-full p-3 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
                            placeholder="Seu e-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {/* Mensagem */}
                    <div>
                        <label className="block text-lg font-semibold text-purple-700" htmlFor="message">
                            Mensagem
                        </label>
                        <textarea
                            id="message"
                            className="w-full p-3 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
                            placeholder="Escreva sua mensagem"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            maxLength={characterLimit}
                            rows="4"
                            required
                        />
                        {/* Contador de caracteres */}
                        <div className="text-right text-sm text-gray-500">
                            {message.length}/{characterLimit} caracteres
                        </div>
                    </div>

                    {/* Botão de Enviar */}
                    <div className="text-center">
                        <button
                            type="button"
                            className="bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 text-white py-3 px-8 rounded-full shadow-lg transform transition-transform duration-300 hover:scale-105"
                            onClick={handleSubmit}
                        >
                            Enviar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Contact;
